
<div class="modal" #modalContainer="" tabindex="-1" [class.hidden]="!visible" [ngClass]="cssClass">
  <div class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-center justify-center h-screen">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
      <div class="max-h-screen bg-white px-4 pt-5 pb-4 text-left overflow-y-auto shadow-xl transform transition-all" [class]="size | modalSize">
        <button class="top-2 right-2 absolute bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" type="button" (click)="close(true)"><span class="sr-only">Close</span>
          <!-- Heroicon name: outline/x-->
          <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
        <ng-template pimModalHost=""></ng-template>
      </div>
    </div>
  </div>
</div>